import $ from "jquery";
import anime from 'animejs/lib/anime.es.js';



$('.trigger-dropdown-menu').on('mouseenter', function(){
  $('.dropdown-menu').removeClass('show');
  if($(this).hasClass('trigger-dropdown-menu--products')) {
    // $(this).addClass('showing');
    $('.dropdown-menu--products').addClass('show');
  }
  if($(this).hasClass('trigger-dropdown-menu--about')) {
    $(this).addClass('showing');
    $('.dropdown-menu--about').addClass('show');
  }
  if($(this).hasClass('trigger-dropdown-menu--news')) {
    $(this).addClass('showing');
    $('.dropdown-menu--news').addClass('show');
  }
});

$('#nav-desktop-menu > li').on('mouseenter', function(){
  if(!$(this).hasClass('trigger-dropdown-menu')) {
    $('.dropdown-menu').removeClass('show');
  }
});

var dropdown = '';

$('.dropdown-menu__both a.link__text').on('mouseenter', function(){
  var $prev = $(this).prev();
  $prev.addClass('active');
});

$('.dropdown-menu__both a.link__text').on('mouseleave', function(){
  var $prev = $(this).prev();
  $prev.removeClass('active');
});


// $('.trigger-dropdown-menu--products').on('mouseenter', function() {
//   $('.dropdown-menu').css({'display':'none', 'opacity':0});
//   $('.dropdown-menu--products').css({'display':'flex', 'opacity':0});
//   $('.dropdown-menu--products').stop(true, true);
//   $('.dropdown-menu--products').animate({
//     opacity: 1
//   }, 300, function() {
//     // Animation complete.
//   });
// });

// $('.trigger-dropdown-menu--about').on('mouseenter', function() {
//   $('.dropdown-menu').css({'display':'none', 'opacity':0});
//   $('.dropdown-menu--about').css({'display':'flex', 'opacity':0});
//   $('.dropdown-menu--about').stop(true, true);
//   $('.dropdown-menu--about').animate({
//     opacity: 1
//   }, 300, function() {
//     // Animation complete.
//   });
// });

// function closeDropDownMenus() {
//   $('.dropdown-menu').animate({
//     opacity: 0
//   }, 300, function() {
//     // Animation complete.
//     $('.dropdown-menu').css({'display':'none'});
//   });
// }

// $('.nav-desktop-dropdowns').on('mouseleave', function() {
//   closeDropDownMenus();
// });

// $('#nav-desktop-menu > li').on('mouseenter', function(){
//   if(!$(this).hasClass('trigger-dropdown-menu')) {
//     closeDropDownMenus();
//   }
// });


$('.link-image-pair .menu-link').on('mouseenter', function(){
  var index = $(this).attr('data-index');
  console.log('index', index);
  var $parent = $(this).closest('.link-image-pair');
  var $images = $parent.find('.image');
  var $image = $parent.find('.image--' + index);
  $images.removeClass('show');
  $image.addClass('show');
});

$('.link-image-pair .menu-link').on('mouseleave', function(){
  var $images = $('.link-image-pair .image');
  $images.removeClass('show');
});

$('.dropdown-menu').on('mouseleave', function(){
  $('.dropdown-menu').removeClass('show');
});

// $('#nav-desktop-menu > li:not(:last-child) > a').append('<svg class="svg-circle" width="100%" height="100%" viewBox="0 0 157 40" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"><path d="M141.029 34.948s22.267-3.767 9.267-15S72.096.481 43.629 3.081c-28.467 2.6-43.067 9.8-40.867 16.867 2.2 7.067 42.263 13.652 85.696 17.433 36.22 0 52.571-2.433 52.571-2.433z" stroke="#B5DCD6" stroke-width="5" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg>');
$('#nav-desktop-menu > li:not(:last-child) > a').append('<svg class="svg-circle" width="100%" height="100%" viewBox="0 0 156.871 39.881"><path data-name="Path 10008" d="M88.195 37.38c36.482 0 52.833-2.433 52.833-2.433s22.267-3.767 9.267-15S72.095.48 43.628 3.08.561 12.88 2.761 19.947 51.712 37.38 88.195 37.38z" fill="none" stroke="#b5dcd6" stroke-linecap="round" stroke-width="5"/></svg>');

$('a svg.svg-circle').on('mouseenter', function(){

  if(!$(this).closest('li').hasClass('current-menu-item')) {
    var $svg = $(this).css({ 'opacity' : 1 });
    var $path = $(this).find('path');
  
    anime({
      targets: $path[0],
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'easeInOutSine',
      duration: 500,
      // delay: function(el, i) { return i * 250 },
      direction: 'alternate',
      loop: false
    });
  }

});

$('a svg.svg-circle').on('mouseleave', function(){
  if(!$(this).closest('li').hasClass('current-menu-item')) {
    var $svg = $(this).css({ 'opacity' : 0 });
  }
});


var $currentMenuItem = $('#nav-desktop-menu li.current-menu-item > a svg.svg-circle');
// changed to 0 to hide active class
var $currentMenuItemSvg = $currentMenuItem.css({ 'opacity' : 0 });
var $currentMenuItemPath = $currentMenuItem.find('path');

anime({
  targets: $currentMenuItemPath[0],
  strokeDashoffset: [anime.setDashoffset, 0],
  easing: 'easeInOutSine',
  duration: 500,
  // delay: function(el, i) { return i * 250 },
  direction: 'alternate',
  loop: false
});

// $('.footer-copyright').on('click', function(){
//   var $paths = $('.svg-circle path').first();

//   anime({
//     targets: $path[0],
//     strokeDashoffset: [anime.setDashoffset, 0],
//     easing: 'easeInOutSine',
//     duration: 1000,
//     // delay: function(el, i) { return i * 250 },
//     direction: 'alternate',
//     loop: false
//   });
// });


